import React, { Suspense, useRef, useEffect } from 'react';
import { Canvas, useFrame, useThree } from '@react-three/fiber';
import { Environment, useGLTF } from '@react-three/drei';

// Ton modèle 3D avec shadows
const LogoModel = React.forwardRef((props, ref) => {
  const { scene } = useGLTF('/models/LogoTypeTEST2.glb');
  const localRef = useRef();

  // Rotation automatique
  useFrame(() => {
    if (localRef.current) {
      localRef.current.rotation.y -= 0.001;
    }
  });


  return (
    <primitive
      ref={(node) => {
        localRef.current = node;
        if (ref) ref.current = node;
      }}
      object={scene}
      scale={1.5}
      {...props}
    />
  );
});

// Caméra qui regarde un point fixe
function CameraLookAt() {
  const { camera } = useThree();

  useEffect(() => {
    camera.lookAt(0, 2.5, 0);
  }, [camera]);

  return null;
}

export default function Logo3D() {
  return (
    <Canvas

      style={{height: '150px', width: '150px', background: "transparent", }}
      camera={{ position: [0, 2.5,6]}}
 
    >
      <Suspense fallback={null}>
        <Environment preset="dawn" />
        <LogoModel />
        <CameraLookAt />
      </Suspense>
    </Canvas>
  );
}
